import axios from "axios";
import alert from "@/lang/AlertMessages.js";
// import label from "@/lang/StaticLabels.js";

function getExcelFile(data) {
  if (!data) return null;
  return data.file || (data.fileContents ? data : null);
}

function getExcelHtml(data) {
  if (!data || !data.html) return null;
  return typeof data.html === "string" ? data.html : data.html.m_StringValue;
}

function saveExcelFile(file) {
  const { fileContents, contentType, fileDownloadName } = file;

  const byteCharacters = atob(fileContents);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const blob = new Blob([new Uint8Array(byteNumbers)], {
    type: contentType,
  });

  const urlBlob = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = urlBlob;
  link.download = fileDownloadName || "sample.xlsx";

  link.click();

  window.URL.revokeObjectURL(urlBlob);
}

export default {
  //Upload Actions ..................................................................................
  getUploads({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("filing/api/v1/Upload/GetDefaults?" + data)
      .then((res) => {
        commit("setUploads", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getUpload({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .get("filing/api/v1/Upload/GetDefaults?" + data)
      .then((res) => {
        commit("setUpload", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  // فهرست ضمیمه‌های فایلینگ را بدون تغییر state برمی‌گرداند
  // (برای گرفتن فایل چند موجودیت به صورت همزمان در یک فرم)
  getUploadsBy({ dispatch }, data) {
    return axios
      .get("filing/api/v1/Upload/GetDefaults?" + data)
      .then((res) => res.data.data || [])
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
        return [];
      });
  },

  addUpload({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    // پرامیس برمی‌گردد تا فراخوان بتواند آپلودها را پشت‌سرهم بفرستد
    // و نتیجه‌ی بولین برمی‌گرداند تا بداند آپلود انجام شده یا نه
    return axios
      .post("filing/api/v1/Upload", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
        return res.status === 200;
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
        return false;
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteUpload({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    // پرامیس برمی‌گردد تا فراخوان بتواند بعد از حذف فایل ادامه دهد
    return axios
      .delete("filing/api/v1/Upload", { data })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: res.data.message,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },
  // Excel Actions......................................................................................

  // ریسپانس ممکن است {data: {fileContents}} یا {data: {file: {fileContents}, html: {...}}} باشد
  // getExcelFile(data) {
  //   if (!data) return null;
  //   return data.file || (data.fileContents ? data : null);
  // },

  // getExcelHtml(data) {
  //   if (!data || !data.html) return null;
  //   return typeof data.html === "string" ? data.html : data.html.m_StringValue;
  // },

  // saveExcelFile(file) {
  //   const { fileContents, contentType, fileDownloadName } = file;

  //   const byteCharacters = atob(fileContents);
  //   const byteNumbers = new Array(byteCharacters.length);

  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }

  //   const blob = new Blob([new Uint8Array(byteNumbers)], {
  //     type: contentType,
  //   });

  //   const urlBlob = window.URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.href = urlBlob;
  //   link.download = fileDownloadName || "sample.xlsx";

  //   link.click();

  //   window.URL.revokeObjectURL(urlBlob);
  // },

  // فقط پیش‌نمایش هدر فایل نمونه را می‌گیرد (بدون دانلود)
  getExcelTemplate({ dispatch, commit }, url) {
    commit("setExcelTemplateHtml", null);
    axios
      .get(url)
      .then((res) => {
        const data = res.data && res.data.data;
        commit("setExcelTemplateHtml", getExcelHtml(data));
      })
      .catch((error) => {
        dispatch("errorGETHandlerSilent", error, { root: true });
      });
  },

  // پیلود می‌تواند رشته‌ی آدرس باشد یا { url, updatePreview }
  // (وقتی فایل پر شده با اطلاعات دانلود می‌شود، پیش‌نمایش قالب نباید عوض شود)
  downloadExcelFile({ dispatch, commit }, payload) {
    const url = typeof payload === "string" ? payload : payload && payload.url;
    const updatePreview =
      typeof payload === "string" ? true : payload.updatePreview !== false;
    if (!url) return;

    axios
      .get(url)
      .then((res) => {
        const data = res.data && res.data.data;
        const file = getExcelFile(data);

        const html = getExcelHtml(data);
        if (html && updatePreview) {
          commit("setExcelTemplateHtml", html);
        }

        if (!file || !file.fileContents) {
          commit("setError", alert.error.server, { root: true });
          return;
        }

        saveExcelFile(file);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
